import * as React from "react";
import "./ChannelPackage.css";

interface IChannelPackageProps {
    description: string;
    name: string;
    points: number;
    src: string;
}

class ChannelPackage extends React.Component<IChannelPackageProps, {}> {
    public description(): {__html: string} {
        return {  __html: this.props.description };
    }

    public render() {
        return (
            <div className="product details">
                <img src={this.props.src} alt="" />
                <h3>{this.props.name}</h3>
                <span>
                    <span className="points">{this.props.points}</span> poeng
                </span>
                <div className="channelDescription" dangerouslySetInnerHTML={this.description()} />
            </div>
        );
    }
}

export default ChannelPackage;